import React, { SVGProps } from 'react'
const SvgTransaction = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={100}
    height={96}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect
      width={30.309}
      height={3.563}
      fill="#EAEBF1"
      rx={1.048}
      transform="scale(-1 1) rotate(20 -171.577 -112.915)"
    />
    <rect
      width={21.627}
      height={3.563}
      fill="#EAEBF1"
      rx={1.048}
      transform="scale(-1 1) rotate(20 -63.856 -248.763)"
    />
    <path
      fill="#3475F2"
      fillRule="evenodd"
      d="M6.998 13.632S.286 14.75 3.91 26.689c.414 1.366 1.913 2.048 3.254 1.56l32.493-11.826"
      clipRule="evenodd"
    />
    <path
      fill="url(#Transaction_svg__a)"
      fillRule="evenodd"
      d="M6.36 13.835s2.788-1.732 6.667 8.925l21.815 59.936c1.479 4.063 5.087 2.71 5.087 2.71L90.883 66.9s3.456-1.258 1.814-5.77L71.045 1.645s-3.634-9.985-11.273-7.205C52.135-2.78 6.36 13.835 6.36 13.835Z"
      clipRule="evenodd"
    />
    <path
      stroke="#FDFFFE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.341}
      d="M23.895 20.21 60.773 6.788"
    />
    <path
      stroke="#FDFFFE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.341}
      d="m27.495 30.101 33.564-12.216"
      opacity={0.5}
    />
    <path
      stroke="#FDFFFE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.341}
      d="m31.372 40.753 36.811-13.399M38.848 61.295 75.66 47.896"
    />
    <path
      stroke="#FDFFFE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4.341}
      d="m35.248 51.404 31.847-11.591M42.725 71.946l31.846-11.59"
      opacity={0.5}
    />
    <rect
      width={43.409}
      height={43.409}
      x={59.642}
      y={37.825}
      fill="url(#Transaction_svg__b)"
      rx={21.704}
      transform="rotate(-20 59.642 37.825)"
    />
    <path
      stroke="#FCFCFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.029}
      d="m94.09 43.919-6.827 14.639-7.32-3.413"
    />
    <defs>
      <linearGradient
        id="Transaction_svg__a"
        x1={77.6}
        x2={47.127}
        y1={71.94}
        y2={-21.038}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5FCEB6" />
        <stop offset={1} stopColor="#588AF2" />
      </linearGradient>
      <linearGradient
        id="Transaction_svg__b"
        x1={67.436}
        x2={142.912}
        y1={43.452}
        y2={75.648}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#443FDD" />
        <stop offset={1} stopColor="#9387FC" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgTransaction
